import { render, staticRenderFns } from "./create-before.vue?vue&type=template&id=6676cb4c&scoped=true"
import script from "./create-before.vue?vue&type=script&lang=js"
export * from "./create-before.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6676cb4c",
  null
  
)

export default component.exports